var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgSparkLineLoadingState = function SvgSparkLineLoadingState(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 58,
    viewBox: "0 0 215 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 43.506L8.25106 44.8554L18.2213 39.4578L26.3787 37.4337L32.7628 31.5243L40.4277 27.3133L50.0235 33.7046L59.0085 35.6124L68.1926 31.5243L77.1362 35.6124L82.1213 40.7906L88.6329 35.6124L96.6234 30.012L101.155 37.4337L105.894 40.7906L110.219 49.7844L115.657 46.8795L122.246 49.7844L128.8 54.9759L133.332 46.8795L139.052 44.3336L143.302 48.2289L147.834 30.012L152.366 17.8675L158.584 15.172L160.523 24.6145L165.055 37.4337L170.947 40.7906L175.391 49.7844H181.823L186.809 57L193.105 56.3253L199.045 37.4337L204.936 30.012L209.015 10.4458L214 1",
    stroke: "url(#paint0_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 152.5,
    y1: 40.6097,
    x2: 214,
    y2: 40.6097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9B2BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B2BD",
    stopOpacity: 0
  })))));
};
var Memo = /*#__PURE__*/memo(SvgSparkLineLoadingState);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "transfix-charts/components/SparkLine/assets/SparkLineLoadingState.62fc290f1bdde8da5478ebf0ffd6fb32.svg";